import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { paySupplementList } from "@/api/gmtool/packageCode";
import addreplenishment from "./components/addreplenishment.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "replenishment",
  components: {
    addreplenishment: addreplenishment
  },
  mixins: [gmTool],
  data: function data() {
    return {
      paramsData: {
        page: 1,
        op_type: '',
        orderId: '',
        pay_channel: '',
        pay_id: '',
        role_id: ''
      },
      list: [],
      total: 0,
      isCode: false,
      codeLists: [],
      supplement: [{
        label: this.$t('supplementReward'),
        value: 'supplement_reward'
      }, {
        label: this.$t('supplementProduct'),
        value: 'supplement_product'
      }]
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      this.reqLoading = true;
      this.paramsData.page = e;
      paySupplementList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.list = res.data.result;
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('time'),
        prop: 'expire'
      }, {
        label: this.$t('itemIdLabel'),
        prop: 'item_id'
      }, {
        label: this.$t('quantity'),
        prop: 'num'
      }];
      var data = JSON.parse(JSON.stringify(this.codeLists)); // data.map(item => {
      //   item.expire = this.$times.timestampToTime(item.expire)
      // })

      this.$export.csv({
        columns: columns,
        data: data
      });
    },
    viewCode: function viewCode(data) {
      this.codeLists = JSON.parse(data);
      this.isCode = true;
    }
  }
};